import type { TabProps } from './TabBar.types'
import cn from 'classnames'
import * as React from 'react'
import { wrapTextChildrenWithTypography } from '../../utils/wrapChildrenWithTypography'
import styles from './Tab.module.css'

export function Tab({ active, children, className, onClick, value, ...attributes }: TabProps) {
  const onClickHandler = () => {
    onClick?.(value)
  }

  return (
    <button
      aria-pressed={active}
      className={cn(styles.tab, { [styles.active]: active }, className)}
      onClick={onClickHandler}
      type="button"
      {...attributes}
    >
      <div className={styles.content}>
        {wrapTextChildrenWithTypography(children, styles.typography)}
      </div>
    </button>
  )
}
